module.exports = __webpack_public_path__ + "img/my wallet .af8f3b09.png";